// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-l_er","galleryItem_borderTopRadius":"c-l_es","galleryItem__image":"c-l_et"};